import * as Ariakit from "@ariakit/react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { useState } from "react";
import DropdownSelect from "../DropdownSelect";
import * as styles from "./Tabs.css";
import type { Props } from "./types";

export default function Tabs<K extends string>({
	value,
	label,
	tabs,
	tabContents,
	cta,
	tabItemConfig,
	tabListConfig,
	className,
	useDropdown,
	onChange,
}: Props<K>) {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div className={`${styles.wrapper} ${className}`}>
			<Ariakit.TabProvider
				defaultSelectedId={value}
				selectedId={value}
				setSelectedId={onChange}
				selectOnMove
			>
				<Ariakit.TabList
					className={`${styles.list(tabListConfig)} ${isOpen ? "open" : "closed"}`}
					aria-label={label}
					style={assignInlineVars({
						[styles.count]: `${tabs.length}`,
					})}
				>
					{!useDropdown && (
						<>
							{tabs.map((tab) => (
								<Ariakit.Tab
									key={tab.key}
									className={styles.tabItem(tabItemConfig)}
									id={tab.key}
									onClick={(e) => e.stopPropagation()}
								>
									{tab.label}
								</Ariakit.Tab>
							))}
							{cta && <div className={styles.ctaContainer}>{cta}</div>}
						</>
					)}
					{useDropdown && (
						<div
							className={`dropdown ${styles.dropdownContainer} ${isOpen ? "open" : "closed"}`}
						>
							<DropdownSelect
								options={tabs.map((tab) => ({
									value: tab.key,
									label: tab.label,
								}))}
								value={value}
								onChange={onChange}
								renderValue={(k) => tabs.find((t) => t.key === k)?.label}
								renderItem={(k) => tabs.find((t) => t.key === k)?.label}
								onOpen={setIsOpen}
							/>
						</div>
					)}
				</Ariakit.TabList>
				<div className={styles.panels}>
					{tabContents?.map((t) => (
						<Ariakit.TabPanel
							key={t.key}
							tabId={t.key}
							className={styles.panel}
						>
							{t.content}
						</Ariakit.TabPanel>
					))}
				</div>
			</Ariakit.TabProvider>
		</div>
	);
}
